import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {DashboardState} from '../../../_contracts/DashboardState';
import Translate from '../../../../../components/translate/Translate';
import {requireImage} from '../../../../../utils/utils';
import {PHOTO_SELECTION_STATE} from '../../../../../../states/dashboard/main/main.settings';

import './styles.scss';

export interface IMainPhotoSelectionProps {
    dashboardState: DashboardState;
    isAndroidOrIphone: 'android' | 'apple';
}

@observer
export class MainPhotoSelection extends TechseeBaseComponent<IMainPhotoSelectionProps> {
    renderInternal(): JSX.Element {
        const {dashboardState, isAndroidOrIphone} = this.props;
        const isAndroid = isAndroidOrIphone === 'android';
        const isInCameraDialog =
            dashboardState.clientRoomStorage.photoSelectionDialogState === PHOTO_SELECTION_STATE.IN_CAMERA_DIALOG;

        return (
            <div className='guidance-container'>
                {dashboardState.displayPhotoStreamGuidnace && !dashboardState.endedTheMeeting && (
                    <div>
                        {isAndroid ? (
                            <main>
                                <div className='margin-bottom-20 guidance-text-one-click'>
                                    <Translate text='WIZARD.MAIN.CAMERA_TAP' />
                                </div>
                                <img
                                    className='img-phone-uploading-image'
                                    src={requireImage('uploading-photo/android/image1(Android).png')}
                                    alt='android view'
                                />
                            </main>
                        ) : (
                            <main>
                                <div className='margin-bottom-20 guidance-text-one-click'>
                                    <Translate text='WIZARD.MAIN.CAMERA_TAP' />
                                </div>
                                <img
                                    className='img-phone-uploading-image'
                                    src={requireImage('uploading-photo/ios/image1(iOS).png')}
                                    alt='iOS view'
                                />
                            </main>
                        )}
                    </div>
                )}

                {isInCameraDialog && (
                    <div>
                        {isAndroid ? (
                            <main>
                                <div>
                                    <div className='orange-text guidance-text-step1'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_ANDROID_STEP1' />
                                    </div>
                                    <div className='orange-text guidance-text-step2'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_STEP2' />
                                    </div>
                                    <div className='orange-text guidance-text-step3'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_ANDROID_STEP3' />
                                    </div>
                                    <img
                                        className='img-phone-uploading-image-camera-dialog1'
                                        src={requireImage('uploading-photo/android/image2(Android).png')}
                                        alt='android view'
                                    />
                                    <img
                                        className='img-phone-uploading-image-camera-dialog2'
                                        src={requireImage('uploading-photo/android/image3(Android).png')}
                                        alt='android view'
                                    />
                                    <img
                                        className='img-phone-uploading-image-camera-dialog3'
                                        src={requireImage('uploading-photo/android/image4(Android).png')}
                                        alt='android view'
                                    />
                                </div>
                            </main>
                        ) : (
                            <main>
                                <div>
                                    <div className='orange-text guidance-text-step1'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_IOS_STEP1' />
                                    </div>
                                    <div className='orange-text guidance-text-step2'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_STEP2' />
                                    </div>
                                    <div className='orange-text guidance-text-step3'>
                                        <Translate text='WIZARD.MAIN.CAMERA_TAP_IOS_STEP3' />
                                    </div>
                                    <img
                                        className='img-phone-uploading-image-camera-dialog1'
                                        src={requireImage('uploading-photo/ios/image2(iOS).png')}
                                        alt='iOS view'
                                    />
                                    <img
                                        className='img-phone-uploading-image-camera-dialog2'
                                        src={requireImage('uploading-photo/ios/image3(iOS).png')}
                                        alt='iOS view'
                                    />
                                    <img
                                        className='img-phone-uploading-image-camera-dialog3'
                                        src={requireImage('uploading-photo/ios/image4(iOS).png')}
                                        alt='iOS view'
                                    />
                                </div>
                            </main>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
